module.exports = __webpack_public_path__ + "static/triogrotesk-medium-v102-477320b1afb5ccdee8c7b985d52035f0.woff";